import http from '@core/fetch'

export default {
  // 获取直播抽奖list
  liveGiftList: body =>
    http('/hps/admin/live/liveGift/liveGiftList', {
      body
    }),

  // 获取中奖list
  giftRecordList: body =>
    http('/hps/admin/live/liveGift/giftRecordList', {
      body
    }),

  // 获取奖项detail
  giftInfo: body => http('/hps/admin/live/liveGift/info', { body }),

  // 删除奖项
  deleteGift: body =>
    http.post('/hps/admin/live/liveGift/deleteGift', {
      body
    }),

  // 终止奖项
  stopGift: body =>
    http.post('/hps/admin/live/liveGift/changeGiftStatus', {
      body
    }),

  // 添加或编辑奖项
  editLiveGift: body =>
    http.post('/hps/admin/live/liveGift/editLiveGift', {
      body
    }),

  // 获取连麦信息
  getMicrophoneInfo: body =>
    http('/hps/admin/live/microphone/info', {
      body
    }),

  // 获取待连麦用户
  getMicrophoneUserList: body =>
    http('/hps/admin/live/microphone/userList', {
      body
    }),

  // 保存连麦信息
  microphoneSetInfo: body =>
    http.post('/hps/admin/live/microphone/setInfo', {
      body
    }),

  // 获取连麦成功list
  getLinkSuccessUsers: body =>
    http('/hps/admin/live/microphone/successfulUserList', {
      body
    })
}
